{
  "scenes": "Scenes",
  "search_scenes": "Search scenes",
  "no_results": "No results",
  "close": "Close",
  "back": "Back",
  "start": "Start",
  "fullscreen": "Fullscreen",
  "compact_controls": "Hide the controls",
  "expand_controls": "Show the controls",
  "toggle_thumbnails": "Scene thumbnails",
  "exit_fullscreen": "Exit fullscreen",
  "zoom_in": "Zoom in",
  "zoom_out": "Zoom out",
  "mute": "Mute",
  "unmute": "Unmute",
  "share": "Share",
  "copy_link": "Copy link",
  "link_copied": "Link copied",
  "vr_mode": "VR mode",
  "gyro": "Gyroscope",
  "gaze_hint": "Look at a marker and hold still: the ring fills and it activates on its own.",
  "help": "Help",
  "language": "Language",
  "map": "Map",
  "floorplan": "Floor plan",
  "floorplan_enlarge": "Enlarge the floor plan",
  "floorplan_shrink": "Shrink the floor plan",
  "floorplan_close": "Close the floor plan",
  "floorplan_show_spots": "Show spots",
  "floorplan_levels": "Floors",
  "map_toggle_hint": "Show or hide the floor plan (M key)",
  "compass": "Compass",
  "loading": "Loading",
  "menu": "Menu",
  "previous_scene": "Previous scene",
  "help_title": "How to move around",
  "help_drag": "Drag to look around",
  "help_zoom": "Mouse wheel or pinch to zoom",
  "help_keys": "Arrow keys to rotate, +/- to zoom, Tab to cycle through points of interest",
  "help_dblclick": "Double-click to zoom into a point",
  "help_map_key": "Press M to show or hide the floor plan",
  "download": "Download",
  "submit": "Submit",
  "sending": "Sending",
  "form_success": "Sent successfully. Thank you.",
  "form_error": "Could not send. Please try again.",
  "required_field": "This field is required",
  "quiz_check": "Check",
  "quiz_correct": "Correct",
  "quiz_incorrect": "Incorrect",
  "quiz_score": "Score",
  "quiz_passed": "Passed",
  "quiz_failed": "Not passed",
  "quiz_report": "Quiz report",
  "quiz_certificate": "Download certificate",
  "quiz_your_name": "Your name for the certificate",
  "quiz_gate_message": "Answer correctly to move on",
  "quiz_question_of": "Question {n} of {total}",
  "quiz_prev": "Previous",
  "quiz_next": "Next",
  "quiz_see_result": "See the result",
  "quiz_review": "Review the questions",
  "quiz_summary_title": "Result",
  "quiz_summary": "You got {correct} of {total} right",
  "treasure_title": "Treasure hunt",
  "treasure_progress": "Found {found} of {total}",
  "treasure_complete": "Hunt complete",
  "before": "Before",
  "after": "After",
  "open_external": "Opens in a new tab",
  "accessible_mode": "Accessible version",
  "made_with_andarama": "Made with Andarama",
  "accessible_intro": "Linear accessible version of the tour with all scenes and contents.",
  "back_to_360": "Back to 360 view",
  "scene_of": "Scene {index} of {total}",
  "narration_wait": "Wait for the narration to finish to continue",
  "autoplay_tour": "Auto tour",
  "stop_autoplay": "Stop auto tour",
  "live_connected": "Connected to the guided tour",
  "live_follow": "Follow the guide",
  "live_free": "Explore freely",
  "live_chat": "Chat",
  "live_send": "Send",
  "live_participants": "{count} participants",
  "live_ended": "The guided tour has ended",
  "welcome_controls": "Controls",
  "poweredby": "Built with Andarama",
  "projection": "Projection",
  "projection_rectilinear": "Normal",
  "projection_littlePlanet": "Little planet",
  "projection_fisheye": "Fisheye",
  "projection_pannini": "Panini",
  "projection_architectural": "Architectural",
  "video_play": "Play",
  "video_pause": "Pause",
  "gallery_prev": "Previous",
  "gallery_next": "Next",
  "floor": "Floor {level}",
  "pdf_page": "Page {page} of {total}",
  "model_ar": "View in your space (AR)",
  "error_load": "Could not load content",
  "transcript": "Transcript",
  "invalid_email": "Enter a valid email",
  "vr_exit": "Exit VR",
  "vr_rotate_device": "Turn your phone sideways to use it with a headset",
  "vr_open_outside": "This content opens outside immersive mode.",
  "vr_queue_open": "Open when leaving VR",
  "vr_exit_and_view": "Exit VR and view it",
  "vr_stay": "Stay in VR",
  "vr_video_outside": "{provider} videos can't play inside the headset. Exit virtual reality to watch it in the tour.",
  "vr_pdf_error": "The document couldn't be opened inside the headset.",
  "video_sound_on": "Turn the sound on",
  "pdf_scroll_up": "Scroll up",
  "pdf_scroll_down": "Scroll down",
  "pdf_read_text": "Read as large text",
  "pdf_read_page": "See the original page",
  "compare_hint": "Point and hold to move the divider",
  "vr_needs_https": "VR mode needs a secure connection (HTTPS).",
  "vr_open_new_tab": "Virtual reality isn't allowed inside this page, so the tour opens in a new tab.",
  "vr_hint_hands": "Point with your hand or controller and pinch to activate",
  "hotspot_navigation": "Navigation",
  "hotspot_text": "Text",
  "hotspot_image": "Image",
  "hotspot_gallery": "Gallery",
  "hotspot_videoFile": "Video",
  "hotspot_embedVideo": "Embedded video",
  "hotspot_audio": "Audio",
  "hotspot_pdf": "PDF document",
  "hotspot_model3d": "3D model",
  "hotspot_web": "Web content",
  "hotspot_form": "Form",
  "hotspot_compare": "Comparison",
  "hotspot_quiz": "Question",
  "hotspot_polygon": "Area",
  "hotspot_tooltip": "Label",
  "hotspot_link": "Link",
  "hotspot_state": "Action",
  "vr_needs_motion": "Looking around by moving your phone needs your permission to read motion and orientation.",
  "vr_allow_motion": "Allow motion",
  "vr_motion_settings": "If no prompt appears, turn it on in Settings › Safari › Motion & Orientation Access and enter again.",
  "treasure_found": "You found it!",
  "treasure_hint": "Hint",
  "kiosk_routes": "Tours",
  "kiosk_exploring": "You are exploring on your own",
  "kiosk_resume": "Back to the tour",
  "kiosk_playing": "Playing “{name}”",
  "kiosk_touch_hint": "Touch the screen to explore yourself",
  "projection_rectilinear_desc": "The normal view: like looking with your eyes.",
  "projection_littlePlanet_desc": "The whole sphere as a tiny planet seen from above.",
  "projection_fisheye_desc": "Curved wide angle: much more fits on screen.",
  "projection_pannini_desc": "Wide without bending vertical lines. Ideal indoors.",
  "projection_architectural_desc": "Keeps verticals straight when looking up or down.",
  "quiz_gate_scene": "Answer correctly to move on",
  "kiosk_ended": "The tour has finished",
  "kiosk_replay": "Watch it again",
  "kiosk_start": "Watch the tour",
  "web_open_external": "Open in a new tab",
  "web_blocked_hint": "If nothing shows here, that site does not allow being embedded in other pages.",
  "autoplay_finished": "Tour finished",
  "quiz_retry": "Try again",
  "quiz_name_for_result": "Your name for the result",
  "quiz_send_result": "Send result",
  "quiz_result_sent": "Result sent",
  "quiz_result_error": "The result could not be sent. Please try again.",
  "form_gate_scene": "Send the form in this scene to move on",
  "form_already_sent": "You have already sent this form. Thank you.",
  "treasure_gate_scene": "Find the treasure in this scene to move on",
  "nav_gate_scene": "Finish what is pending in this scene to move on",
  "treasure_complete_all": "You have found all the treasures!",
  "treasure_show_hint": "Show a hint",
  "treasure_no_hint": "No hint here: keep looking.",
  "treasure_none_here": "There are no treasures left to find in this scene."
}
